
import React, { Component } from 'react';
import { Modal, Button, ProgressBar } from 'tinper-bee';
import { nativeMs } from 'mutants-microfx';
import { Ticon} from 'tplus-components-touch';
import './style.less';

const updateLogo  = "https://newretail.static.chanjet.com/update-logo.png";
export default class CheckUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            progres: 0,
            visible: false,
            errorType: false
        }
        this.onCancel = this.onCancel.bind(this);
        this.handleAgain = this.handleAgain.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    onCancel() {
        this.props.handleModal(false)
    }
    handleAgain() {
        this.handleInit()
    }
    handleClose() {
        this.setState({ visible: false })
    }
    handleInit(){
        nativeMs.sendIpcRendererMethod('CheckForUpdate')
        nativeMs.onIpcRendererMethod("Message", ret => {
            console.log(ret);
            let dt = JSON.parse(ret);
            switch (dt.status) {
                case 0:
                    this.setState({ message: '更新失败，请重试！', errorType: true })
                    console.log("错误：" + JSON.stringify(dt.details))
                    break;
                case 1:
                    this.setState({ message: dt.value, progres: 0 })
                    break;
                case 2:
                    this.setState({ message: dt.value, progres: Math.floor(Math.random() * 50), visible: true })
                    break;
                case 3:
                    this.setState({ message: dt.value, visible: false })
                    break;
            }
        })
        //注意：“downloadProgress”事件可能存在无法触发的问题，只需要限制一下下载网速就好了
        nativeMs.onIpcRendererMethod("DownloadProgress",(event, progressObj)=>{
            console.log('进度条:' + JSON.stringify(progressObj))
            //this.setState({ progres: progressObj && progressObj.percent || 0 })
        })
        nativeMs.onIpcRendererMethod("IsUpdateNow", () => {
            this.setState({ progres: 100 })
            setTimeout(() => nativeMs.sendIpcRendererMethod('IsUpdateNow'), 3600);
        })
    }
    componentDidMount(){
        this.handleInit()
    }
    componentWillUnmount() {
        nativeMs.removeIpcRendererMethod(["Message", "DownloadProgress", "IsUpdateNow"])
    }
    render() {
        const { message, progres, visible, errorType } = this.state;
        return (
            <Modal
                width={400}
                show={visible}
                backdropClosable={false}
                className='CheckModalContainer'
            >
                <Modal.Body className='body'>

                    <div className='container'>
                        <div className='top'>
                            <div className='left'>
                                <img src={updateLogo} />
                            </div>
                            <div className='right'>
                                <div className='b1'>畅捷通T+零售收银发现新版本</div>
                                <div className='b2'>{message}</div>
                            </div>
                        </div>
                        <div className='floatBox'>
                            <Ticon className='icon' type="guanbi-yuan" onClick={this.handleClose} />
                        </div>
                        <div className='bottom'>
                            <div className='first' style={{ display: (errorType == false ? '' : 'none') }}>
                                <ProgressBar now = {progres} label={`${progres}%`} />
                            </div>
                            <div className='second' style={{ display: (errorType == true ? '' : 'none') }}>
                                <span>{'检查更新出错'}</span>
                                <Button onClick={this.handleAgain} colors="primary">重试</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>);
    }
}
